import React from 'react'
import PropTypes from 'prop-types'
import { SERVICESKU, TIRESKU, FRONTTIRESKU, REARTIRESKU, STAGGEREDPREFIX } from './constants'
import Service from './components/Service'
import Tire from './components//Tire'

const SKU_TYPE = {
  [SERVICESKU]: Service,
  [TIRESKU]: Tire,
  [FRONTTIRESKU]: Tire,
  [REARTIRESKU]: Tire
}

const SkuDescription = ({
  skuType,
  ...props
}) => {
  const correctedSkuType = skuType.toLowerCase()
  const SkuByType = SKU_TYPE[correctedSkuType]

  return (
    <SkuByType { ...props } staggeredPrefix={ STAGGEREDPREFIX[correctedSkuType] } />
  )
}

SkuDescription.propTypes = {
  skuType: PropTypes.string
}

export default SkuDescription
